import Marionette from 'backbone.marionette';
import NavlinkView from './navlink_view';
export default Marionette.CollectionView.extend({
  childView: NavlinkView,
  tagName: "ul",
  className: "nav navbar-nav"
});